<template>
  <div class="intro-y box p-5">
    <div class="text-lg font-bold mb-4 flex flex-row">
      ประวัติเอกสาร:
    </div>
    <div>
      <table class="table">
        <thead class="bg-gray-700 dark:bg-dark-1 text-white">
          <tr>
            <th width="100%">Description</th>
          </tr>
        </thead>
        <tbody v-if="props.items.length">
          <tr v-for="(history, index) in props.items" :key="index">
            <td class="border-b dark:border-dark-5">
              {{ history }}
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td class="text-center">ไม่พบรายการ</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
export default defineComponent({
  props: {
    items: Array,
    default: () => {
      return null
    }
  },
  setup(props) {
    return {
      props
    }
  }
})
</script>

<style scoped></style>
